import { useTranslation } from 'react-i18next'

const GrownupEnd = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="grownup-end-title"
      fill="none"
      {...props}
    >
      <title id="grownup-end-title">{t('antagonists:grownup:components:end')}</title>
      <defs>
        <clipPath id="grownup-b">
          <path
            d="M1620.42 204.09c-7.34.47-26.58 41.3-55.6 50.7-29.04 9.4-31.48 10.63-32.71 19.62-1.23 8.99 4.9 21.26 2.46 24.12-2.46 2.86-8.59-12.26-13.9-13.49-5.32-1.23-11.45 2.86-7.36 15.12 4.09 12.26 13.09 24.12 17.99 23.31 4.9-.83 6.96-2.04 6.96-2.04s0 14.32 12.68 22.49c12.68 8.19 27.39 26.98 56.02 21.68 28.62-5.32 39.24-25.35 44.16-33.94 4.9-8.59 4.9-23.31 4.9-23.31s12.21 5.88 15.07-.25c2.86-6.13 1.28-9.97 1.68-25.1.4-15.12 0-20.03-5.32-19.22-5.32.83 0 28.21-1.63 32.71s-3.67-1.23-6.13-6.53-9.4-16.76-17.99-39.24c-8.59-22.49-8.59-47.43-21.26-46.6l-.03-.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="grownup-c">
          <path
            d="M1548.72 325.7s4.18 29.26 2.54 39.43 15.63 42.53 31.98 57.23c16.35 14.72 30.52 22.35 30.52 22.35s18.71-19.81 28.35-32.89c9.63-13.09 10.9-31.8 8-37.42-2.91-5.63-6.91-7.63-7.63-17.08s0-20.53 0-20.53l-93.76-11.08Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:none}.e{fill:#f3decd}.f{fill:#f2934a}.g{fill:#e6f1e2}.h{fill:#e3ebde}.i{fill:#ffd628}.j{fill:#dfbe84}.k{fill:#c48648}.l{fill:#d47241}.m{fill:#3d6b2a}.n{fill:#899586}.o{fill:#75c6cf}.p{clip-path:url(#grownup-c)}.q{clip-path:url(#grownup-b)}'
          }
        </style>
      </defs>
      <path
        d="M1451.53 793.81s0 70.5 13.42 139.34c13.42 68.82 36.94 162.84 36.94 208.16s10.07 154.45 18.46 211.51c8.39 57.08 23.87 82.18 23.87 82.18s26.86 5.04 45.32 3.35c18.46-1.68 43.64-10.07 43.64-10.07s3-45.24 3-134.22-20.14-100.72-16.79-141.01c3.35-40.29-.49-230.31 1.68-231.65 2.17-1.36 70.5 224.95 68.82 263.55-1.68 38.6-6.72 85.61-3.35 152.76 3.35 67.15 4.06 94.23 4.06 94.23s36.94 6.72 53.71 10.07c16.79 3.35 63.78-20.14 63.78-20.14s7.7-80.79-2.37-142.91c-10.07-62.12-15.11-87.3-11.76-125.9 3.35-38.6 6.72-147.73 3.35-216.55-3.35-68.82-48.68-184.66-48.68-184.66s-293.77 40.29-297.14 41.97l.03-.02Z"
        style={{
          fill: '#ffd628',
        }}
      />
      <path
        d="M1528.69 311.65c-2.49.39-3.97 2.31-3.45 4.7.51 2.39 2.69 3.49 4.95 3.28 2.68-.25 3.62-2.41 3.35-4.92-.19-1.77-2.27-3.47-4.85-3.07Z"
        style={{
          fill: '#75c6cf',
        }}
      />
      <path
        d="M1458.22 861.47c8.08 23.71 2.69 37.86 4.16 51.98s3.08 40.74 3.08 40.74-8.4-2.66-13.04-12.88-1.72-22.32-9.25-20.72c-7.51 1.6-3.76 21.1.96 26.93 4.72 5.83 18.06 6.27 21.24 11.84 3.18 5.57 2.44 9.82 2.44 9.82s-28.95-1.08-38.12-4.78c-9.16-3.71-24.15-38.35-26.8-49.2-2.64-10.85 13.59-35.59 8.83-60.33-4.77-24.76 38.38-17.1 46.47 6.62l.02-.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1432.45 423.4c-23.53 7.31-32.22 54.55-41.92 110.05-12.18 69.53-22 150.84-19.55 169.57 4.4 33.67 23.02 173.95 23.02 173.95l75.05-4.13s-5.86-26.36 1.47-118.59 41-297.21 17.57-314.77c-23.43-17.57-54.23-16.54-55.63-16.1v.02Z"
        style={{
          fill: '#899586',
        }}
      />
      <path
        d="M1449.01 413.13c-51.1 15.63-42.73 76.62-35.37 137.03 7.36 60.41 17.68 95.77 35.37 108.3 17.68 12.53 41.25-11.79 48.62-52.31 7.36-40.52 0-106.09 0-141.45s-24.05-59.08-48.62-51.57Z"
        style={{
          fill: '#899586',
        }}
      />
      <path
        d="M1561.74 361.29s-30.96 20.16-59.69 31.95c-28.73 11.79-67.56 25.99-67.56 25.99s30.72 131.66 22.62 181.03c-8.1 49.37-19.89 150.34-16.94 183.48 2.95 33.15 11.42 101.14 11.42 101.14s62.33-21.29 174.24-31.87c111.9-10.56 149.48-27.13 149.48-27.13s3.23-19.44 7.66-74.68c4.41-55.26-55.48-153.87-45.9-216.5s24.88-100.18 11.62-118.59c-13.26-18.43-63.85-8.84-90.38-35.35-26.53-26.53-63.43-26.54-63.43-26.54l-33.15 7.09v-.02Z"
        style={{
          fill: '#899586',
        }}
      />
      <path
        d="M1618.36 172.19c-7.11-1.97-48.66-9.4-73.18 7.76-24.54 17.18-40.07 65.01-39.24 82.18.83 17.18 15.95 20.85 18.81 29.44 2.86 8.59 15.53 26.58 15.53 26.58l109.58-7.76s17.13-5.51 18.36-17.36c1.23-11.86-2.46-17.47 2.85-33.82 5.32-16.35 6.18-23.63-.35-48.17-6.53-24.54-22.05-34.95-33.53-38.44-7.83-2.37-11.45 1.63-18.81-.4Z"
        style={{
          fill: '#d47241',
        }}
      />
      <path
        d="M1620.42 204.09c-7.34.47-26.58 41.3-55.6 50.7-29.04 9.4-31.48 10.63-32.71 19.62-1.23 8.99 4.9 21.26 2.46 24.12-2.46 2.86-8.59-12.26-13.9-13.49-5.32-1.23-11.45 2.86-7.36 15.12 4.09 12.26 13.09 24.12 17.99 23.31 4.9-.83 6.96-2.04 6.96-2.04s0 14.32 12.68 22.49c12.68 8.19 27.39 26.98 56.02 21.68 28.62-5.32 39.24-25.35 44.16-33.94 4.9-8.59 4.9-23.31 4.9-23.31s12.21 5.88 15.07-.25c2.86-6.13 1.28-9.97 1.68-25.1.4-15.12 0-20.03-5.32-19.22-5.32.83 0 28.21-1.63 32.71s-3.67-1.23-6.13-6.53-9.4-16.76-17.99-39.24c-8.59-22.49-8.59-47.43-21.26-46.6l-.03-.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <g
        style={{
          clipPath: 'url(#grownup-b)',
        }}
      >
        <path
          d="M1610.78 242.04s10.64-3.71 18.24-4.61c7.6-.91 17.85 3.97 17.85 3.97l-1.53 5.44s-11.94-4.01-15.73-2.51c-4.33 1.72-17.63 4.65-17.63 4.65s-1.75-7.36-1.2-6.96v.02ZM1588.58 241.32s-10.95-2.68-18.59-2.88c-7.65-.19-17.4 5.64-17.4 5.64l2.04 5.27s11.52-5.12 15.43-3.97c4.46 1.3 18 2.96 18 2.96s1.06-7.49.54-7.04l-.02.02Z"
          style={{
            fill: '#c48648',
          }}
        />
      </g>
      <path
        d="M1548.72 325.7s4.18 29.26 2.54 39.43 15.63 42.53 31.98 57.23c16.35 14.72 30.52 22.35 30.52 22.35s18.71-19.81 28.35-32.89c9.63-13.09 10.9-31.8 8-37.42-2.91-5.63-6.91-7.63-7.63-17.08s0-20.53 0-20.53l-93.76-11.08Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <g
        style={{
          clipPath: 'url(#grownup-c)',
        }}
      >
        <path
          d="M1505.73 371.71s72.47 40.37 111.21 30.03c48.62-13 93.27-32.02 90.19-30.03l9.11 106.28-207.49 23.28-3.03-129.55Z"
          style={{
            fill: '#e6f1e2',
          }}
        />
      </g>
      <path
        d="M1578.49 319.1c-1.23 2.66 5.07 5.78 9.13 9.52 4.06 3.76 9.95 8.59 15.88 9.87 3.59.77 19.99-4.23 22.17-9.18.98-2.22-.35-6.16-4.21-9.28-3.86-3.13-6.05-3.03-9.21-3.13-3.17-.12-5.74 1.92-8.29.84-2.53-1.08-2.61-3.64-6.7-3.81-4.09-.19-7.53 1.53-11.87 2.11-4.03.52-5.81.72-6.91 3.08l.02-.02Z"
        style={{
          fill: '#f2934a',
        }}
      />
      <path
        d="m1626.23 269.95 6.42 1.4.66-3.3-8.35-1.92s.99 3.82 1.28 3.84v-.02Z"
        style={{
          fill: '#3d6b2a',
        }}
      />
      <path
        style={{
          fill: '#3d6b2a',
        }}
        d="m1625.08 267 8.64-4.11-.99-2.98-10.11 4.63 2.46 2.46z"
      />
      <path
        d="M1625.03 261.78c2.88 1.52 3.87 4.53 2.27 7.29s-4.7 3.15-7.36 1.95c-3.15-1.41-4.06-4.09-2.71-7.09.96-2.12 4.83-3.71 7.8-2.14v-.02ZM1571.72 273.05l-7.95 3.87-1.55-2.63 9.18-5.04s.61 3.67.34 3.77l-.02.02Z"
        style={{
          fill: '#3d6b2a',
        }}
      />
      <path
        style={{
          fill: '#3d6b2a',
        }}
        d="m1570.83 270.3-9.14-1.93.3-3 8.37 1.45.47 3.48z"
      />
      <path
        d="M1569.75 265.92c-2.27 2.32-2.32 5.49.05 7.63 2.36 2.14 5.46 1.63 7.63-.32 2.56-2.31 1.89-5.32-.32-7.76-1.55-1.73-5-1.94-7.34.45h-.02Z"
        style={{
          fill: '#3d6b2a',
        }}
      />
      <path
        d="M1655.52 248.22s-14.32-2.49-30.79-.89c-17.79 1.73-18.31 6.7-20.9 8.62-1.62 1.2-2.04.52-5.96.62-3.92.1-4.26.99-6-.03-2.76-1.65-3.77-6.55-21.64-6.55-16.56 0-30.54 3.23-30.54 3.23l-1.23 8.83s4.78.2 6.33 7.51c1.55 7.31 2.98 23.04 23.82 22.38 20.83-.64 23.01-17.92 24.05-21.9 1.21-4.67 1.35-7.44 2.81-7.97.94-.34 4.29-.49 5.25-.25 1.52.37 1.92 3.13 3.57 7.65 1.41 3.86 5.25 20.83 26.07 19.45 20.8-1.38 20.7-17.18 21.54-24.61.83-7.41 3.96-7.49 3.96-7.49l-.37-8.62.02.02Zm-77.06 37.44c-7.88 4.58-19.72 2.49-24.39-3.2-4.67-5.69-5.29-14.4-4.83-18.98.69-6.97 7.76-8.66 19.12-9.5s19.13 1.36 19.77 9.8c.62 8.44-.24 16.4-9.67 21.88Zm66.07-8.34c-4.09 6.11-14.43 10.59-24.35 6.11-9.94-4.48-12.16-12.63-12.35-21.09-.19-8.46 7.78-10.95 19.17-11.22s18.59.72 19.96 7.6c.89 4.51 1.68 12.48-2.41 18.59h-.02Z"
        style={{
          fill: '#e3ebde',
        }}
      />
      <path
        d="M1666.23 299.98c-2.49.39-3.97 2.31-3.45 4.7.51 2.39 2.69 3.49 4.95 3.28 2.68-.25 3.62-2.41 3.35-4.92-.19-1.77-2.27-3.47-4.85-3.07ZM1530.38 312.83c-2.49.39-3.97 2.31-3.45 4.7.51 2.39 2.69 3.49 4.95 3.28 2.68-.25 3.62-2.41 3.35-4.92-.19-1.77-2.27-3.47-4.85-3.07Z"
        style={{
          fill: '#f3decd',
        }}
      />
      <path
        d="M1781.87 839.72c-3.59 24.81 4.46 61.16 5.61 75.3 1.15 14.15-.4 27.37-.4 27.37s10.29 1.9 12.97-8.99c2.68-10.9-.57-22.97 7.12-22.77 7.68.2 5.73 20.77 2.16 27.35-3.57 6.59-12.92 16.64-15.02 22.7s2 14.82 2 14.82 21.98-18.26 30.32-23.6 18.36-36.95 18.95-48.1c.61-11.13-26.98-59.71-26.83-84.9.13-25.21-33.25-3.97-36.85 20.83l-.02-.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1750.04 415.62c21.31 8.99 87.13 196.6 89 230.53 1.87 33.9 13 215.25 13 215.25l-71.14 11.49s-6.6-26.34-30.74-115.66-66.49-351.79-66.49-351.79 19.69-9.48 66.38 10.21v-.02Z"
        style={{
          fill: '#899586',
        }}
      />
    </svg>
  )
}
export default GrownupEnd
